<template>
  <div class="lblFont" id="template">
    <el-radio-group
      v-if="!isRgp"
      style="text-align: left; width: 100%"
      @change="changeBar"
      v-model="bar"
      :disabled="!absRelEnable"
    >
      <!-- <div v-for="(item,index) in barShown" :key="index" style="margin-top:10px;text-align:left;"> -->
      <el-radio
        v-for="(item, index) in barShown"
        :key="index"
        :label="colorBarProps.bar[index]"
        style="margin-top: 10px"
        >{{ item }}</el-radio
      >
      <!-- <br /> -->
      <!-- </div> -->
    </el-radio-group>
    <el-divider v-if="!isRgp"></el-divider>
    <el-row type="flex" align="middle" justify="start" style="text-align: left">
      <!-- {{ $t('langcfg.txtStepVal') }}:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
      <el-col :span="objSpans.step + 1" style="margin-top: 10px; margin-bottom: 10px"
        >{{ $t("langcfg.txtRange") }}:</el-col
      >
      <el-col v-if="!isRgp">{{ stepVal }}</el-col>
      <el-col v-else>
        <el-radio-group v-model="propSettings.step" @change="changeRgpStep">
          <el-radio class="font-color" :label="1.6666666666666667">0 ~ 100 μm</el-radio>
          <el-radio class="font-color" :label="150">0 ~ 150 μm</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row type="flex" justify="start" align="middle" style="text-align: left">
      <el-col :span="objSpans.style">{{ $t("langcfg.txtColorStyle") }}:</el-col>
      <el-col>
        <el-select
          @change="changeBar"
          v-if="colorBarProps && colorBarProps.style"
          :placeholder="''"
          v-model="propSettings.style"
        >
          <el-option
            v-for="(item, id) in colorBarProps.style"
            :key="item"
            :label="styleShown[id]"
            :value="item"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-divider v-if="!isRgp"></el-divider>
    <el-row
      v-if="!isRgp"
      type="flex"
      justify="start"
      align="middle"
      style="margin-bottom: 10px; text-align: left"
    >
      <el-col :span="objSpans.num" style="width: 25%">{{ $t("langcfg.txtNum") }}:</el-col>
      <el-col>
        <el-radio-group @change="changeBar" v-model="num" :disabled="numDisabled">
          <el-radio class="font-color" :style="rdoStyle" :label="61">{{
            $t("langcfg.txtDense")
          }}</el-radio>
          <el-radio class="font-color" :label="31">{{ $t("langcfg.txtSparse") }}</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row
      v-if="
        !isRgp &&
        colorBarProps.stepUnit &&
        Object.keys(colorBarProps.stepUnit).length > 1 &&
        !isUnitFixed
      "
      type="flex"
      justify="start"
      align="middle"
      style="text-align: left"
    >
      <el-col :span="objSpans.unit" style="width: 25%">{{ $t("langcfg.txtUnit") }}:</el-col>
      <el-col>
        <el-radio-group @change="changeBar" v-model="propSettings.unit" :disabled="!unitEnable">
          <el-radio
            v-for="(item, id2) in Object.keys(colorBarProps.stepUnit)"
            :key="id2"
            class="font-color"
            :style="rdoStyle"
            :label="item"
          ></el-radio>
        </el-radio-group>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { MAPSTYLES } from "../shared/index";

export default {
  name: "SettingsTemplate",
  props: {
    name: { type: String, default: "" },
    parentForm: { type: String, default: "" },
    colorBarProps: Object,
    propSettings: Object,
    mapIndexUI: Number,
    indexInForm: { type: Number, default: 0 },
    isRgp: { type: Boolean, default: false },
    absRelEnable: { type: Boolean, default: true },
    unitEnable: { type: Boolean, default: true }
  },
  data: function () {
    return {
      num: 0,
      bar: "",
      objSpans: { step: 4, style: 4, num: 4, unit: 4 },
      isUnitFixed: false,
      rdoStyle: {
        width: "60px"
      }
    };
  },
  mounted: function () {
    if (window.settings.language === "zh_CN" || window.settings.language === "en_US") {
      this.objSpans = { step: 4, style: 4, num: 4, unit: 4 };
      this.rdoStyle.width = window.settings.language === "zh_CN" ? "60px" : "110px";
    } else if (window.settings.language === "ja") {
      this.objSpans = { step: 7, style: 14, num: 4, unit: 4 };
      this.rdoStyle.width = "80px";
    } else if (window.settings.language === "de") {
      this.rdoStyle.width = "100px";
    } else if (window.settings.language === "it") {
      this.rdoStyle.width = "110px";
    }
    this.init();
  },
  watch: {
    "propSettings.num": function () {
      this.init();
    },
    "propSettings.bar": function () {
      this.init();
    },
    mapIndexUI: function () {
      this.init();
    }
  },
  methods: {
    init: function () {
      this.num = this.propSettings.num;
      this.bar = this.propSettings.bar;
      this.propSettings.step = this.getStep(this.propSettings.bar);

      if (this.name === "curvature" && this.mapIndexUI === MAPSTYLES["FRP"]) {
        this.isUnitFixed = true;
      } else {
        this.isUnitFixed = false;
      }
    },
    getStep: function (bar) {
      if (this.isRgp) {
        return this.propSettings.step;
      }
      let unit = this.propSettings.unit;

      let arrStep = this.colorBarProps.stepUnit[unit];

      if (bar.indexOf("Abs") >= 0) {
        return arrStep[0];
      } else if (bar.indexOf("Fine") >= 0) {
        return arrStep[1];
      } else if (bar.indexOf("Medium") >= 0) {
        return arrStep[2];
      }
    },
    changeBar: function (val) {
      if (this.propSettings.style === "style3") {
        this.propSettings.num = 26;
        this.propSettings.bar = "AbsNormal";
      } else if (this.propSettings.style === "style5") {
        this.propSettings.num = 16;
        this.propSettings.bar = this.bar;
      } else {
        if (this.num !== 61 && this.num !== 31) {
          this.num = 61;
        }
        this.propSettings.num = this.num;
        this.propSettings.bar = this.bar;
      }
      this.propSettings.step = this.getStep(this.propSettings.bar);
    },
    changeRgpStep() {
      if (this.propSettings.step === 150) {
        this.propSettings.bar = "Abs";
        this.propSettings.cntVal = -1;
        this.propSettings.unit = "μm";
      } else {
        this.propSettings.bar = "Rel";
        this.propSettings.cntVal = 50;
        this.propSettings.unit = "D";
      }
    }
  },
  computed: {
    numDisabled() {
      console.log(this.name);

      return (
        (this.parentForm === "fourierAnalysis" &&
          [0, 1, 3, 4].includes(this.indexInForm) &&
          ["style3", "style5"].includes(this.propSettings.style)) ||
        (this.parentForm === "fourmaps" &&
          (([0, 1, 3].includes(this.indexInForm) &&
            ["style3", "style5"].includes(this.propSettings.style)) ||
            (this.indexInForm === 2 && this.propSettings.style === "style5"))) ||
        (this.parentForm === "largemap" &&
          ["heightf", "curvature", "elevation"].includes(this.name) &&
          this.propSettings.style === "style5") ||
        (this.parentForm === "keratoconus" &&
          ((this.indexInForm === 0 &&
            ["style3", "style5"].includes(this.propSettings.style) &&
            this.name === "curvature") ||
            (this.indexInForm === 1 &&
              ["style5"].includes(this.propSettings.style) &&
              this.name === "elevation")))
      );
    },
    stepVal: function () {
      if (!this.isRgp) {
        return `${this.propSettings.step <= 0 ? "" : this.propSettings.step}${this.propSettings.unit}`;
      }
    },
    barShown: function () {
      let tmpShown = [];
      let unit = this.propSettings.unit;
      let arrStep = this.colorBarProps.stepUnit[unit];
      for (let i = 0; i < this.colorBarProps.bar.length; i++) {
        let tmp = this.colorBarProps.bar[i];
        if (tmp.indexOf("Abs") >= 0) {
          tmpShown.push(
            `${this.$t("langcfg.txtBarAbs")} (${arrStep[0] === 0 ? "" : arrStep[i]}${unit})`
          );
        } else if (tmp.indexOf("Fine") >= 0) {
          tmpShown.push(`${this.$t("langcfg.txtBarRelFine")} (${arrStep[1]}${unit})`);
        } else if (tmp.indexOf("Medium") >= 0) {
          tmpShown.push(`${this.$t("langcfg.txtBarRelMedium")} (${arrStep[2]}${unit})`);
        }
      }
      return tmpShown;
    },
    styleShown: function () {
      let arr = [];
      if (this.colorBarProps && this.colorBarProps.style) {
        for (let id in this.colorBarProps.style) {
          let tmp = this.colorBarProps.style[id];
          switch (tmp) {
            case "standard":
              arr.push(this.$t("langcfg.txtStandard"));
              break;
            case "style1":
              arr.push(this.$t("langcfg.txtStyle1"));
              break;
            case "style2":
              arr.push(this.$t("langcfg.txtStyle2"));
              break;
            case "style3":
              arr.push(this.$t("langcfg.txtStyle3"));
              break;
            case "style4":
              arr.push(this.$t("langcfg.txtStyle4"));
              break;
            case "style5":
              arr.push(this.$t("langcfg.txtStyle5"));
              break;
            case "fluorescence":
              arr.push(this.$t("langcfg.txtFluorescence"));
          }
        }
      }
      return arr;
    }
  }
};
</script>
<style lang="less">
.lblFont {
  font-size: 30px;
  color: #bec0cc;
}
#template .el-radio__label {
  font-size: 30px;
  color: #bec0cc;
  vertical-align: middle;
}
#template .el-radio__inner {
  width: 30px;
  height: 30px;
}
#template .el-tabs__item {
  font-size: 30px;
  color: #bec0cc;
  margin-bottom: 5px;
}

#template {
  .el-radio__input.is-disabled .el-radio__inner,
  .el-radio__input.is-disabled.is-checked .el-radio__inner {
    background-color: #bec0cc;
    border-color: #bec0cc;
  }
  .el-radio__input.is-disabled.is-checked .el-radio__inner::after {
    background-color: black;
  }
}
</style>



// WEBPACK FOOTER //
// src/topography/components/SettingsTemplate.vue